import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { PulseLoader } from 'halogenium';
import './CreateMembershipTransactionModal.scss';
import MembershipRepository from '../../app/Merchant/Repository/MembershipRepository';
import MerchantSettingKey from '../../app/Common/Enum/MerchantSettingKey';
var portalRoot = null;

class CreateMembershipTransactionModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#create-membership-transaction-modal').length == 0) {
            const content = '<div id="create-membership-transaction-modal" class="create-membership-transaction-modal" style="position:absolute; z-index:1501"></div>'
            $('body').prepend(content)
        }
        portalRoot = document.getElementById("create-membership-transaction-modal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}

class CreateMembershipTransactionModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            membership: this.initMembership(),
            errors: {},
            topupInfo: {},
        }
        this.modalId = "create-membership-transaction-bs-modal"
    }
    initMembership = () => {
        if (this.props.membership && this.props.membership.id) {
            return {
                ...this.props.membership
            }
        }
        return {}
    }
    isLoading(isLoading, callback) {
        if (!this.unmounted) {
            this.setState({isLoading}, () => {callback && callback()})
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);
        this.clearTimer()
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                this.props.onYes && this.props.onYes()
            }
        }
        this.escListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '27'){
                this.props.onNo && this.props.onNo()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener);
        $(document).keyup(this.escListener);

        if (this.props.autoShow && this.modalId) {
            $('#'+this.modalId)
            .off('hidden.bs.modal')
            .on('hidden.bs.modal', () => {
                this.props.onModalClosed && this.props.onModalClosed()

                // https://stackoverflow.com/a/24914782
                // Fix double bootstrap modal issue where after the top most modal is closed,
                // the remaining modal unable to scroll
                $('.modal:visible').length && $(document.body).addClass('modal-open')
            })
            .modal();
        }

        $('#'+ this.modalId)
            .off('show.bs.modal')
            .on('show.bs.modal', function() {
                const zIndex = 1040 + 10 * $('.modal:visible').length;
                $(this).css('z-index', zIndex);
                setTimeout(() => $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack'));
            });

        // We can intercept the modal before close event to "cancel" closing of
        // the modal
        $('#'+ this.modalId)
            .on('hide.bs.modal', () => {
                return this.attemptCloseModal()
            })
    }
    attemptCloseModal = () => {
        if (!this.checkAllowCloseModal(this.forceClose)) {
            return false
        }
        this.props.onNo && this.props.onNo()
        return true
    }
    forceClose = () => {
        this.close(true)
    }
    // Parent to call this to dismiss the modal
    close = (forceClose) => {
        if (forceClose) {
            this.removeOnHideListener()
        }
        $('#'+this.modalId).modal('hide')
    }
    clearTimer = () => {
        if (this.errorTimer) {
            clearTimeout(this.errorTimer)
        }
    }
    onYes = () => {
        const { membership, topupInfo, } = this.state
        // if (!topupInfo || !(topupInfo.point > 0) || !topupInfo.remark) {
        //     if (!topupInfo.remark) {
        //         alert()
        //     }
        //     return
        // }

        let required = {
            // DataKey : Label
            remark          : lang.remark,
            point           : lang.point,
        }

        let errors = {}
        let hasError = false
        let errorKeyToRemove = []
        Object.keys(required).forEach(key => {
            if (!topupInfo[key]) {
                errorKeyToRemove.push(key)
                errors[key] = `"${required[key]}" ${lang.required_field.toLowerCase()}`
                hasError = true
            }
        })

        this.setError(errors, errorKeyToRemove)
        if (hasError) {
            return
        }


        this.setState({
            isSaving: true
        }, () => {
            MembershipRepository.getInstance()
            .topup(membership, topupInfo)
            .then(() => {
                setTimeout(() => {
                    this.props.onYes && this.props.onYes()
                }, 200)
            })
            .catch(err => {
                alert(err.message)
                // if (err.code == 1000) {
                //     // Handle error code
                // }
            })
            .finally(() => {
                this.setState({
                    isSaving: false,
                })
            })
        })
    }

    onCancelClicked = () => {
        $('#'+this.modalId).modal('hide')
    }
    getButtons = () => {
        return (
            <div style={{display: "flex"}}>
                <div>
                    <button onClick={() => {
                        this.setState({
                            isSaving: true
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    isSaving: false
                                })
                            }, 5000);
                        })
                    }} className="btn btn-success btn-sm">Trigger Save</button>
                </div>
                <div style={{flex: "1 0 100px", textAlign: "right"}}>
                    <button onClick={this.attemptCloseModal} className="btn btn-danger btn-sm mr-2">{this.props.noText || lang.cancel}</button>
                    <button onClick={this.onYes} className="btn btn-success btn-sm">{this.props.yesText || lang.confirm}</button>
                </div>
            </div>
        )
    }
    removeOnHideListener = () => {
        $('#'+ this.modalId)
            .off('hide.bs.modal')
    }
    checkAllowCloseModal = (closeModal) => {
        if (this.state.isEdited) {
            if (confirm(lang.changes_not_saved_sure_to_close)) {
                if (closeModal) {
                    setTimeout(closeModal, 200)
                }
            }
            return false
        }
        else if (this.state.isSaving) {
            return false
        }
        return true
    }
    onClose = () => {
        this.props.onClose && this.props.onClose()
    }

    onOtherInfoChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    setError = (errors, keyToRemoveAfterTimeout) => {
        this.clearTimer()
        this.setState({errors})
        this.errorTimer = setTimeout(() => {
            let errors = {...this.state.errors}
            keyToRemoveAfterTimeout.forEach(key => {
                delete(errors[key])
            })
            this.setState({
                errors,
            })
        }, 5000);
    }

    onTopupInfoChange = (e) => {
        this.setState({
            isEdited: true,
            topupInfo: {
                ...this.state.topupInfo,
                [e.target.name]: e.target.value,
            },
        }, () => {
            console.log(this.state.topupInfo)
        })
    }

    render() {
        const { membership = {}, errors = {}, topupInfo } = this.state
        return (
            <CreateMembershipTransactionModalPortal>
                <div id={this.modalId} style={{zIndex:"1500"}} className="modal fade" role="dialog">
                    <div className={`modal-dialog ${this.props.modalSize || "modal-md"}`}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" id="modal-two-title">{lang.topup_point}</h4>
                            </div>
                            <div className="modal-body container-fluid">
                                <h4>{membership.name} - #{membership.membership_number}</h4>
                                <form>
                                    <table id="membership-transaction-form-table">
                                        <thead></thead>
                                        <tbody>
                                            <tr>
                                                <td>{lang.point}</td>
                                                <td>:</td>
                                                <td>
                                                    <InputField
                                                        valueKey="point"
                                                        topupInfo={topupInfo}
                                                        onTopupInfoChange={this.onTopupInfoChange}
                                                        errors={errors}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{lang.remark}</td>
                                                <td>:</td>
                                                <td>
                                                    <InputField
                                                        valueKey="remark"
                                                        topupInfo={topupInfo}
                                                        placeholder="Bonus point / Purchase RM 100 = 1000 point, etc"
                                                        onTopupInfoChange={this.onTopupInfoChange}
                                                        errors={errors}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </form>
                            </div>
                            <div className="modal-footer">
                                {
                                    this.state.isSaving ?
                                    <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "right" }} /> :
                                    this.getButtons()
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </CreateMembershipTransactionModalPortal>
        )
    }
}

class InputField extends Component {
    render() {
        const { topupInfo } = this.props
        return (
            <>
                <input name={this.props.valueKey} className="form-control" placeholder={this.props.placeholder || ""} type="text" value={topupInfo[this.props.valueKey] || ""} onChange={this.props.onTopupInfoChange} />
                {
                    this.props.errors && this.props.errors[this.props.valueKey] &&
                    <div>
                        <span className="error-span">
                            {this.props.errors[this.props.valueKey]}
                        </span>
                    </div>
                }
            </>
        )
    }
}
CreateMembershipTransactionModal.defaultProps = {
    customBody:null,
    message: "",
    buttonLayout: "default",
}
export default CreateMembershipTransactionModal;